<template>
  <div id="price">
    <section class="hero is-medium is-bold is-primary">
      <div class="hero-body">
        <div class="container">
            <div class="level">
              <div class="has-text-left">
                <h2 class="subtitle">
                  Pricing plans
                </h2>
                <h2 class="title">
                  Start for free, <br>then pay as you go.
                </h2>
              </div>

              <div class="has-text-right">
                <div v-show="activePlanBox != ''">
                  <a class="button is-warning is-large is-focused" @click="goCheckout">Go Checkout</a><br><br>
                  <img src="@/assets/powered_by_stripe.png" width="100"/>
                </div>
              </div>
            </div>

            <div class="pricing-table is-comparative">
              <div class="pricing-plan">
                <div class="plan-header">Starter</div>
                <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency"></span>Free</span></div>
                <div class="plan-items">
                  <div class="plan-item">100 images to analyze per month</div>
                </div>
                <div class="plan-footer">
                  <div v-show="!profileIcon" @click="login">
                    <img width="200px" src="@/assets/btn_google_signin_light_normal_web@2x.png"/>
                  </div>
                  <div v-show="profileIcon">
                    <button class="button is-fullwidth" disabled>Current Plan</button>
                  </div>
                </div>
              </div>

              <div class="pricing-plan is-info" id="startups" @click="setCheckOutActive('startups', 25)">
                <div class="plan-header">Startups</div>
                <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>25</span>/month</div>
                <div class="plan-items">
                  <div class="plan-item">500 images to analyze per month</div>
                </div>
                <div class="plan-footer">
                  <button class="button is-fullwidth">Choose</button>
                </div>
              </div>

              <div class="pricing-plan is-success" id="enterprice" @click="setCheckOutActive('enterprice', 100)">
                <div class="plan-header">Enterprise</div>
                <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency"></span>Pay as you go</span></div>
                <div class="plan-items">
                  <div class="plan-item">$0.05 per image to analyze</div>
                  <div class="plan-item">$100 deposit to start and no additional payment <br>until the balance is used up</div>
                </div>
                <div class="plan-footer">
                  <button class="button is-fullwidth">Choose</button>
                </div>
              </div>
            </div>

            <div class="box" v-show="profileIcon">
              <p>Hi <strong>{{displayName}}!</strong></p>
              <p>You are currently a <strong>Starter</strong> member.</p>
              <p>Here's documentation on how to use DetectX API...(editing)</p>
            </div>

            <p>REFUND AND CANCELLATION POLICY- Current and past charges are non-refundable.</p>
            <p>Cancellation must be done in 14 days after the payment date.
            Cancellation requests submitted closer to the payment date may incur extra charges which DetectX is not required to refund.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import helper from '@/helper'

export default {
  data() {
    return {
      activePlanBox: '',
      activePriceBox: 0,
    }
  },
  computed: {
    profileIcon() {
      return helper.profileIcon()
    },
    displayName() {
      return helper.displayName()
    }
  },
  watch: {
    activePlanBox: function(newVal) {
      switch (newVal) {
        case 'startups':
          var priceBox = document.getElementById('enterprice')
          priceBox.classList.remove('is-active')
          break;
        case 'enterprice':
          var priceBox = document.getElementById('startups')
          priceBox.classList.remove('is-active')
      }
    }
  },
  methods: {
    setCheckOutActive(val, val2) {
      var priceBox = document.getElementById(val)
      if (val == this.activePlanBox) {
        this.activePlanBox = ''
        priceBox.classList.remove('is-active')
      } else {
        priceBox.classList.toggle('is-active')
        this.activePlanBox = val
        this.activePriceBox = val2
      }
    },
    login () {
      return helper.firestoreLogin()
    },
    goCheckout() {
      helper.updatePurchaseView(true)
      this.$router.push('/order/'+this.activePlanBox+'/'+this.activePriceBox)
    }
  }
}
//is-active
</script>
